const styles = (theme) => ({
  container: {
    display: 'flex',
    width: '100%',
    backgroundColor: theme.color.white,
    padding: theme.spacing(2.5),
    alignItems: 'center',
    justifyContent: 'space-between',
    '& > button:first-child': {
      marginRight: theme.spacing(2.5),
    },
  },

  saveButton: {
    '&:hover': {
      '& $onHoverHide': {
        display: 'none',
      },
      '& $onHoverShow': {
        display: 'block',
      },
    },
  },
  onHoverShow: {
    display: 'none',
  },
  onHoverHide: {
    display: 'block',
  },
});

export default styles;
